import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import './header.css'
import {ReactComponent as Logo} from '../../assets/images/logo.svg'
import {languageManager} from "../../utils/i18n";
import {useMediaQuery} from "../../hooks";
import LanguageSwitcher from "../LanguageSwitcher";

const Header = () => {
	const t = key => languageManager.t(key);
	const location = useLocation();

	const [showPresent, setShowPresent] = useState(false);
	const [soon, setSoon] = useState(false);
	const [isOpen, setIsOpen] = useState(false)

	const currentPath = location.pathname;
	const mobile = useMediaQuery("(max-width: 768px)");

	const isPastPage = currentPath  === '/past';
	const isNowPage = currentPath  === '/arch' || currentPath  === '/residents' || currentPath  === '/popup';
	const isContactsPage = currentPath  === '/contacts';
	const isArchPage = currentPath  === '/arch';
	const isResidentsPage = currentPath  === '/residents';
	const isPopupPage = currentPath  === '/popup';
	const isHomePage = location.pathname === '/';

	const onHandleCross = () => {
		setIsOpen(false)
		!isNowPage && setShowPresent(false)
	}

	const onFutureClick = () => {
		setSoon(true)
		setTimeout(() =>setSoon(false), 3000);
	}

	const onPresentClick = () => {
	 setShowPresent(!showPresent)
	}

	useEffect(() => {
		isNowPage && setShowPresent(true);
	}, [isNowPage]);

	return (
		<header className="header">
			<div className="header__container">
				<div className="header__inner">
					<div className={`header__logo ${isHomePage ? 'header__logo-home' : 'header__logo-other'}`}>
						<Link to="/" onClick={onHandleCross}>
							<Logo/>
						</Link>
					</div>
				</div>
				{mobile &&
					<div className='header__menu'>
						<div className="header__menu_top_nav">
							{isOpen ? <>
								<Link to="/past" className="top_nav_item" style={{backgroundColor: isPastPage ? '#BADDE2' : 'white'}} onClick={onHandleCross}>
									{t('nav.past')}
								</Link>
								<div 	className="top_nav_item"
								        style={{backgroundColor: isNowPage ? '#BADDE2' : 'white'}} onClick={onPresentClick}>
									<span className="footer__link">{t('nav.present')}</span>
								</div>

							</> : <button className='top_nav_btn' style={{width: 'calc(100% - 66px)', marginRight: '18px'}} onClick={() =>setIsOpen(true)}>{t('nav.menu')}</button> }
							<LanguageSwitcher/>
						</div>
						{isOpen &&
							<>
								{showPresent && (
									<ul className="top_nav__submenu" >
										<li className="top_nav__submenu-item top_nav_item" style={{backgroundColor: isArchPage ? '#BADDE2' : 'white'}}>
											<Link to="/arch" className="top_nav__sublink" onClick={onHandleCross}>
												{t('nav.archaeology')}
											</Link>
										</li>
										<li className="top_nav__submenu-item top_nav_item" style={{backgroundColor: isResidentsPage ? '#BADDE2' : 'white'}}>
											<Link to="/residents" className="top_nav__sublink" onClick={onHandleCross}>
												{t('nav.residents')}
											</Link>
										</li>
										<li className="top_nav__submenu-item top_nav_item" style={{backgroundColor: isPopupPage ? '#BADDE2' : 'white'}}>
											<Link to="/popup" className="top_nav__sublink" onClick={onHandleCross}>
												{t('nav.popup')}
											</Link>
										</li>
									</ul>
								)}
								<div className="top_nav__bottom">
									<div  className="top_nav_item" onClick={onFutureClick} style={{backgroundColor: soon ? '#BADDE2' : 'white'}}>
										{soon ?  t('nav.soon') : t('nav.future')}
									</div>

									<Link to="/contacts" className="top_nav_item"  style={{backgroundColor: isContactsPage ? '#BADDE2' : 'white'}} onClick={onHandleCross}>
										{t('nav.contacts')}
									</Link>

									<button className="top_nav_item" onClick={onHandleCross}>X</button>
								</div>
							</>
						}
					</div>
				}
			</div>
		</header>
	);
};

export default Header;